import { render, staticRenderFns } from "./LgFinderPageConsultarRequisicoesCompra.vue?vue&type=template&id=5c06e164"
import script from "./LgFinderPageConsultarRequisicoesCompra.vue?vue&type=script&lang=js"
export * from "./LgFinderPageConsultarRequisicoesCompra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports